export const uniqueObjects = (objects, sortBy = "id") => {
  const set = new Set();
  let unique = [];

  for (const obj of objects) {
    const key = JSON.stringify(obj);

    if (!set.has(key)) {
      set.add(key);
      unique.push(obj);
    }
  }

  unique = unique.filter(el => !!el);

  return unique.sort((a, b) => a[sortBy] - b[sortBy]);
};
